import React, { useEffect } from "react"
import { useDispatch } from "react-redux"

import Button from "@/components/core/Button/Button"
import { getSubscribeButtonAnalytics } from "@/components/AccountSettings/v1/Communication/analytics"

import { sanitizeInnerHtml } from "@/utils/helper"

import communicationStyle from "@/components/AccountSettings/v1/Communication/index.module.scss"

import { toggleSiteWideWarning } from "@/store/features/genericSlice"

const Communication = ({ i18n = {}, subscriptionPath = "" }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(toggleSiteWideWarning())
  }, [])

  return (
    <div className={`${communicationStyle?.communicationStyleWrapper}`}>
      <div className={`account-communication`}>
        <div className="account-settings__section-header">
          <h2 className="account-settings__section-title">
            {i18n?.communicationPreferences}
          </h2>
        </div>
        <div className="account-communication__content">
          <div className="account-communication-content">
            <div className="account-communication__title">
              {i18n?.subscribeForEmail}
            </div>
            <div className="account-communication__desc">
              {sanitizeInnerHtml(i18n?.communicationDesc)}
            </div>
          </div>
          <div className="account-communication__cta">
            <Button
              type="ghost"
              size="small"
              flexible
              to={subscriptionPath}
              label={i18n?.subscribe}
              target="blank"
              className="gbh-data-layer"
              data-gbh-data-layer={getSubscribeButtonAnalytics()}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Communication
